import { render, staticRenderFns } from "./PicksCarousel.vue?vue&type=template&id=0d308d18&scoped=true&"
import script from "./PicksCarousel.vue?vue&type=script&lang=js&"
export * from "./PicksCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PicksCarousel.vue?vue&type=style&index=0&id=0d308d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d308d18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
